import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';

Chart.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    intersect: false,
    mode: 'index' as const,
  },
  animation: {
    duration: 800,
    easing: 'easeInOutQuart' as const,
  },
  plugins: {
     legend: {
      position: 'top' as const,
      labels: {
        font: {
          size: 18,
          weight: '700' as const,
          color:"#000"
        },
        padding: 20,
        boxWidth: 25,
        boxHeight: 25,
        borderRadius: 10,
        usePointStyle: true,
        pointStyle: 'rectRounded' as const,
      }
    },
    tooltip: {
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      titleColor: '#1f2937',
      bodyColor: '#374151',
      borderColor: '#e5e7eb',
      borderWidth: 1,
      cornerRadius: 8,
      displayColors: false,
      padding: 12,
      titleFont: {
        size: 14,
        weight: '600' as const,
      },
      bodyFont: {
        size: 13,
        weight: '500' as const,
      },
      callbacks: {
        label: function (context: any) {
          return `${context.parsed.y} photos `;
        }
      }
    },
  },
  scales: {
    x: {
      ticks: {
        color: '#6b7280',
        font: {
          size: 12,
          weight: '500' as const,
        },
        padding: 8,
      },
      grid: {
        display: false,
      },
      border: {
        color: '#f3f4f6',
        width: 1,
      },
    },
    y: {
      beginAtZero: true,
      ticks: {
        color: '#6b7280',
        font: {
          size: 12,
          weight: '500' as const,
        },
        padding: 12,
        callback: function (value: any) {
          return value + '';
        }
      },
      grid: {
        display: true,
        color: '#f3f4f6',
        lineWidth: 1,
      },
      border: {
        display: false,
      },
    },
  },
  elements: {
    bar: {
      borderRadius: {
        topLeft: 6,
        topRight: 6,
        bottomLeft: 0,
        bottomRight: 0,
      },
      borderSkipped: false,
    },
  },
};

const BarChart: React.FunctionComponent<{ data: any }> = (props) => {

  const getDataWithModernDesign = (data: any) => {
    if (!data) return null;

    const customData = {
      ...data,
      datasets: data.datasets?.map((dataset: any, index: number) => {
        const colors = [
          {
            bg: 'rgba(99, 102, 241, 0.8)',
            border: '#6366f1',
            hover: 'rgba(99, 102, 241, 0.9)',
          }
        ];

        const colorSet = colors[index % colors.length];

        return {
          ...dataset,
          backgroundColor: colorSet.bg,
          borderColor: colorSet.border,
          borderWidth: 2,
          hoverBackgroundColor: colorSet.hover,
          hoverBorderColor: colorSet.border,
          hoverBorderWidth: 3,
          barThickness: 'flex' as const,
          maxBarThickness: 60,
          minBarLength: 2,
        };
      })
    };

    return customData;
  };

  return (
    <div
      style={{
        height: '320px',
        width: '100%',
        padding: '8px',
        background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)',
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      }}
    >
      {props.data && <Bar data={props.data} options={options} />}
    </div>
  );
};

export default BarChart;